import adjustmentAPI from '@/services/API/adjustment'



const fetchAdjustments = function({ commit, state}, {puid, productId, itemId, inventoryId}) {
  commit('SET_LOADING_ADJUSTMENTS', true);
  adjustmentAPI.fetchAdjustment({puid, productId, itemId, inventoryId, paging:'no'})
    .then(adjustments=>{
      commit('SET_ADJUSTMENTS', adjustments);
      commit('SET_LOADING_ADJUSTMENTS', false);
    })
};

const deleteAdjustment = function ({commit, state}, index){
  let adjId = state.adjustments[index].id;
  commit('SET_LOADING_ADJUSTMENTS', true);
  return adjustmentAPI.deleteAdjustment(adjId)
    .then(()=>{
      commit('REMOVE_ADJUSTMENT', index);
      commit('SET_LOADING_ADJUSTMENTS', false);
      return Promise.resolve();
    }).catch(err=>{
      commit('SET_LOADING_ADJUSTMENTS', false);
      return Promise.reject(err);
    })
}

const deleteAdjustmentItem = function ({commit, state}, index){
  let adjId = state.adjustments[index].id;
  let adjItemId = state.adjustments[index].inventory_adjustment_details[0].id;
  commit('SET_LOADING_ADJUSTMENTS', true);
  return adjustmentAPI.deleteAdjustmentItem(adjId, adjItemId)
    .then(()=>{
      commit('REMOVE_ADJUSTMENT', index);
      commit('SET_LOADING_ADJUSTMENTS', false);
      return Promise.resolve();
    }).catch(err=>{
      commit('SET_LOADING_ADJUSTMENTS', false);
      return Promise.reject(err);
    })
}

export default {
  fetchAdjustments,
  deleteAdjustment,
  deleteAdjustmentItem
};
